import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import security from 'yeself-client-common/security/SecurityReducer';
import featureFlags from 'yeself-client-common/featureFlags/FeatureFlagsReducer';

import organizations from 'Console/data/organizations/OrganizationsReducer';
import app from 'Console/data/app/reducer';
import accounts from 'Console/data/accounts/reducer';
import applications from 'Console/data/applications/reducer';
import applicationDetail from 'Console/data/applicationDetail/reducer';
import audit from 'Console/data/audit/reducer';
import notifications from 'Console/data/notification/reducer';
import analytics from 'Console/data/analytics/AnalyticsReducer';

const consoleReducer = (history) =>
    combineReducers({
        app,
        accounts,
        audit,
        organizations,
        applications,
        applicationDetail,
        notifications,
        router: connectRouter(history),
        security,
        featureFlags,
        analytics,
    });

export default consoleReducer;
